import React, { ReactNode } from 'react';
import styles from './GridContainer.module.scss';

interface GridContainerProps {
    children: ReactNode;
    className?: string;
}

export const GridContainer = ({ children, className = '' }: GridContainerProps) => {
    return (
        <div className={`${styles.gridContainer} ${className}`} draggable="false">
          	{children}
        </div>
    );
};